
export const nextgen_measurements = [
    "alar_angle", "cheek_angles", "cutaneous_upper_lip", "face_height", "fsp_angle", "lip_length",
    "lip_protrusion_upper", "naso_labial_angle_prn", "nose_depth", "nose_height", "nose_protrusion",
    "nose_supramenton_angle", "nose_width", "sellion_pronasale_angle", "sellion_pronasale_distance",
    "subnasale_sellion_length", "top_lip_curvature", "LHC", "UHC", "swift_vector",
    "nostril_angle_between_plane_normals", "nostril_centroid_x", "nostril_ellipse_minor",
    "nostril_ellipse_major", "nostril_rotation", "nostril_ellipse_perimeter"
];